export const PricingTierDescription: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div className='font-muted-foreground mb-6 mt-3 text-sm'>{children}</div>
  );
};
